<template>
  <div>
    <div :class="labelClasses" class="label">{{ label }}</div>
    <r-autocomplete
      ref="autocomplete"
      :options="options"
      :value="value"
      :tabindex="tabindex"
      no-results-text="אין תוצאות"
      :autofocus="autofocus"
      :error="validationError"
      :error-message="validationErrorMessage"
      :bg-color="bgColor"
      :input-style="{ padding: '5px'}"
      :input-debounce="200"
      :filter-debounce="1"
      behavior="menu"
      color="riseup-blue"
      @blur="onBlur"
      @focus="onFocus"
      @input="onInput"
      v-on="$listeners" />
  </div>
</template>

<script>
import RAutocomplete from '@/components/base/RAutocomplete';
import WithValidation from '@/mixins/WithValidation';

export default {
  name: 'DefaultAutocomplete',
  mixins: [WithValidation],
  components: { RAutocomplete },
  data() {
    return {
      focused: false,
    };
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: Object,
    label: String,
    autofocus: Boolean,
    tabindex: Number,
  },
  computed: {
    labelClasses() {
      if (this.focused) {
        return ['r-text-bold', `text-${this.color}`];
      }
      return [`text-${this.color}`];
    },
    color() {
      if (this.error) {
        return 'riseup-danger-red';
      }
      return this.focused ? 'riseup-blue' : 'riseup-black';
    },
    bgColor() {
      if (this.focused) {
        return 'riseup-white';
      }
      return 'riseup-beige';
    },
  },
  methods: {
    onBlur() {
      this.validate();
      this.focused = false;
    },
    onFocus() {
      this.focused = true;
    },
    onInput(value) {
      this.reset();
      this.$emit('input', value);
    },
    focus() {
      this.$refs.autocomplete.focus();
    },
  },
};
</script>

<style scoped lang="scss">
.label {
  font-size: 12px;
}
</style>
